// 电损信息下载页面
import React, { Component } from "react";
import { Form, Select, Radio, DatePicker, Tooltip, Button, TreeSelect, message } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { getCityList } from "@/fetch/fetchApi";
import fetchHandler from "@/fetch/fetchHandler";
import "@/assets/stylus/addDownloadPage.styl";
import moment from "moment";

const FormItem = Form.Item;
const { Option } = Select;
const { RangePicker } = DatePicker;
const layout = {
  labelCol: {
    span: 4,
  },
  wrapperCol: {
    span: 16,
  },
};

class AddDownloadTask extends Component {
  constructor(props) {
    super(props);
    // const  getFieldDecorator = form.getFieldDecorator;
    this.props = props;
    this.state = {
      radio1value: "0", // 日期筛选方式：0：按天，1：按月
      radio2value: "0", // 日期维度：0：细分，1：汇总
      ywmapOption: [{ value: "", text: "全部" }], // 运营类型初始化
      areaType: 0, // 地区选择类型 ： 0：全国，1：省份，2：城市
      btnClicked: true, // 提交按钮是否可点 ： true：不可点，false:可点
      dlType: "1",
    };
  }

  // 设置Form的ref
  formRef = React.createRef();

  /**
   * 日期筛选方式切换：0：按天，1：按月
   */
  radioChange1 = (e) => {
    this.formRef.current.resetFields(["time"]);
    this.setState({
      radio1value: e.target.value,
      btnClicked: true,
    });
  };

  /**
   * 日期维度切换：0：细分，1：汇总
   */
  radioChange2 = (e) => {
    this.setState({
      radio2value: e.target.value,
    });
  };

  /**
   * 获取城市数据
   */
  getCityList = () => {
    fetchHandler(getCityList).then((res) => {
      const fetchPickerOptions = res.data;
      let formatOptionsStr = JSON.stringify(fetchPickerOptions);
      formatOptionsStr = formatOptionsStr.replace(new RegExp("label", "g"), "title");
      formatOptionsStr = formatOptionsStr.replace(new RegExp("value", "g"), "value");
      formatOptionsStr = formatOptionsStr.replace(new RegExp("children", "g"), "children");
      const cityAryy = JSON.parse(formatOptionsStr);
      cityAryy.map((item) => {
        item.key = item.value;
        item.disabled = true; // 城市筛选，父级省份设置不可选
        item.children.map((item2) => {
          item2.key = item2.value;
          delete item2.children; // 删除子区域数据
          return true;
        });
        return true;
      });
      this.allCityArry = [...cityAryy];
      const arr = cityAryy.map((item) => {
        const foo = {
          title: item.title,
          value: item.value,
          key: item.value,
        };
        return foo;
      });
      this.provenceAryy = [{
        key: "all",
        title: "全部省份",
        value: "all",
        children: arr }];
      this.quanguoCityArry = [
        {
          title: "全国",
          value: "000000",
          key: "000000",
        },
      ];
      /**
       * 地区数据维度--------
       * quanguoCityArry：全国选项------------地区类型为全国
       * provenceAryy：省级选项---------------地区类型为身份
       * allCityArry：城市选择----------------地区类型为城市
       */
      this.setState({
        quanguoCityArry: [...this.quanguoCityArry],
        provenceAryy: [...this.provenceAryy],
        allCityArry: [...this.allCityArry],
      });
    });
  };

  /**
   * 切换地区选择类型
   * 0:全国
   * 1：省份
   * 2：城市
   */

  changeCityType = (value) => {
    this.formRef.current.resetFields(["area"]);
    this.setState({
      selectCityValue: value, // 地区选择类型标识
      btnClicked: true,
    });
  };

  /**
   * 选择城市执行，体检按钮是否可点击
   *
   */
  changeCity = (value) => {
    if (value.length === 0) {
      this.setState({
        btnClicked: true,
      });
    }
  };

  /**
   * 选择数据范围 ： 0：地区维度，1：电站维度
   *
   */
  changeDataDimention = (value) => {
    this.formRef.current.resetFields(["areaType"]);
    this.formRef.current.resetFields(["area"]);
    this.setState({
      areaType: value,
      btnClicked: true,
      selectCityValue: "",
    });
    // 如果是充电成功率订单维度下载，则时间维度只能选择天
    if (this.state.dlType === "2" && value === "2") {
      this.setState({
        radio1value: "0",
        radio2value: "0",
      });
      this.formRef.current.setFieldsValue({
        timeDimention: "0",
        mode: "0",
      });
    }
  };

  /**
   * form表单数据修改时执行
   * 判断必填项是否已填，提交按钮是否可点击
   */
  changeValues = (changedValues, allValues) => {
    console.log(allValues);
    if (
      allValues.indicatorType
      && allValues.dataDimention
      && allValues.area
      && allValues.area.length > 0
      && allValues.stubType
      && allValues.timeDimention
      && allValues.time
      && allValues.mode
    ) {
      this.setState({
        btnClicked: false,
      });
    } else {
      this.setState({
        btnClicked: true,
      });
    }
  };

  /**
   * 点击提交按钮执行方法
   */
  submitForm = () => {
    const info = this.formRef.current.getFieldsValue();
    let citys = "";
    if (info.area instanceof Array) {
      info.area.map((item) => {
        citys += `${item.value || item},`;
        return true;
      });
    } else {
      citys = info.area.value;
    }

    const param = {
      dType: info.indicatorType,
      dataDim: info.dataDimention,
      cityIds: citys,
      operationProperty: "3",
      operationMode: info.typeItem === "s" ? "" : info.typeItem,
      type: info.stubType === "s" ? "" : info.stubType,
      isSummary: info.mode,
      timeDimention: info.timeDimention,
      startTime:
        info.timeDimention === "0"
          ? info.time[0].format("YYYY-MM-DD")
          : info.time[0].format("YYYY-MM"),
      endTime:
        info.timeDimention === "0"
          ? info.time[1].format("YYYY-MM-DD")
          : info.time[1].format("YYYY-MM"),
      selectCityType: this.state.selectCityValue,
    };

    this.props.getInfo(param);
  };

  /**
   * 重置form表单
   */
  resetForm = () => {
    this.formRef.current.resetFields([
      "indicatorType",
      "dataDimention",
      "area",
      "yunyingType",
      "typeItem",
      "stubType",
      "timeDimention",
      "time",
      "mode",
    ]);
    this.setState({
      areaType: "0",
      btnClicked: true,
    });
  };

  selectDLType = (val) => {
    this.setState(
      {
        dlType: val,
      },
      () => {
        if (val === "2" && this.state.areaType === "2") {
          this.setState({
            radio1value: "0",
            radio2value: "0",
          });
          this.formRef.current.setFieldsValue({
            timeDimention: "0",
            mode: "0",
          });
        }
      },
    );
  };

  componentWillMount() {
    // 获取城市数据
    this.getCityList();
  }
  // 空字符
  // requiredExcludesNullStr = (rule, value) => {
  //     if (value || value === '') {
  //         return Promise.resolve();
  //     }
  //     return Promise.reject();
  // }

  render() {
    /**
     * 设置不可选择日期，不可在2020-1-1之前
     */
    const disabledDate = (current) => {
      if (current < moment(new Date("2020-01-01")).endOf("day")) {
        return current < moment(new Date("2020-01-01")).endOf("day");
      }
      return current && current > moment().endOf("day");
    };
    const Content = (
      <div className='download-task-build-content' style={{ width: "650px" }}>
        <Form {...layout} ref={this.formRef} onValuesChange={this.changeValues}>
          {/* 指标类型 */}
          <div className='formTit'>指标类型</div>
          <div className='indicatorType'>
            <FormItem label='  ' initialValue='1' name='indicatorType'>
              <Select onSelect={this.selectDLType}>
                <Option value='1'>设备完好率</Option>
                <Option value='2'>充电成功率</Option>
              </Select>
            </FormItem>
          </div>
          {/* 数据范围 */}
          <div className='formTit'>数据范围</div>
          <FormItem
            label='数据维度'
            name='dataDimention'
            initialValue='0'
            rules={[{ required: true, message: "   " }]}>
            {this.state.dlType === "1" ? (
              <Select onChange={this.changeDataDimention}>
                <Option value='0'>地区维度</Option>
                <Option value='1'>电站维度</Option>
                <Option value='2'>终端维度</Option>
              </Select>
            ) : (
              <Select onChange={this.changeDataDimention}>
                <Option value='0'>地区维度</Option>
                <Option value='1'>电站维度</Option>
                <Option value='2'>订单维度</Option>
              </Select>
            )}
          </FormItem>

          <div className='yunyingtypeFomr'>
            <FormItem label='地区' name='areaType' rules={[{ required: true, message: "   " }]}>
              <Select placeholder='可选范围' onChange={this.changeCityType}>
                <Option value='0'>全国</Option>
                <Option value='1'>省份</Option>
                {this.state.areaType === "0" ? null : <Option value='2'>城市</Option>}
              </Select>
            </FormItem>
            <div className='fengge'>-</div>
            {
              this.state.selectCityValue === "0" ? (
                <FormItem name='area' rules={[{ required: true, message: "   " }]}>
                  <TreeSelect
                    disabled={!this.state.selectCityValue}
                    onChange={this.changeCity}
                    placeholder='请选择地区'
                    allowClear
                    showSearch
                    treeCheckable
                    treeCheckStrictly
                    treeNodeFilterProp='title'
                    treeData={this.state.quanguoCityArry}
            />
                </FormItem>) : null
            }
            {
              this.state.selectCityValue === "1" ? (
                <FormItem name='area' rules={[{ required: true, message: "   " }]}>
                  <TreeSelect
                    disabled={!this.state.selectCityValue}
                    onChange={this.changeCity}
                    placeholder='请选择地区'
                    allowClear
                    showSearch
                    treeCheckable
                    treeNodeFilterProp='title'
                    treeData={this.state.provenceAryy}
                />
                </FormItem>) : null
            }
            {
               (this.state.selectCityValue !== "1" && this.state.selectCityValue !== "0") ? (
                 <FormItem name='area' rules={[{ required: true, message: "   " }]}>
                   <TreeSelect
                     disabled={!this.state.selectCityValue}
                     onChange={this.changeCity}
                     placeholder='请选择地区'
                     allowClear
                     showSearch
                     treeCheckable
                     treeCheckStrictly
                     treeNodeFilterProp='title'
                     treeData={this.state.allCityArry}
                />
                 </FormItem>) : null
            }
          </div>

          <div className='yunyingtypeFomr'>
            <FormItem
              label='运营类型'
              name='typeItem'
              initialValue=''>
              <Select>
                <Option value="">全部</Option>
                <Option value="0">非直营</Option>
                <Option value="1">直营</Option>
              </Select>
            </FormItem>
          </div>

          <FormItem
            label='设备类型'
            name='stubType'
            initialValue='s'
            rules={[{ required: true, message: "   " }]}>
            <Select>
              <Option value='s'>全部</Option>
              <Option value='0'>交流(AC)</Option>
              <Option value='1'>直流(DC)</Option>
              <Option value='2'>交直流</Option>
            </Select>
          </FormItem>

          {/* 时间范围 */}
          <div className='formTit'>时间范围</div>
          <FormItem
            label='时间维度'
            name='timeDimention'
            initialValue='0'
            rules={[{ required: true, message: "   " }]}>
            <Radio.Group
              value={this.state.radio1value}
              defaultValue="0"
              onChange={this.radioChange1}
              disabled={this.state.dlType === "2" && this.state.areaType === "2"}>
              <Radio value='0'>按天</Radio>
              <Radio value='1'>按月</Radio>
            </Radio.Group>
          </FormItem>
          <FormItem label='时间' name='time' rules={[{ required: true, message: "   " }]}>
            {this.state.radio1value === "0" ? (
              <RangePicker
                disabledDate={disabledDate}
                placeholder={["年/月/日", "年/月/日"]}
                format='YYYY/MM/DD'
              />
            ) : (
              <RangePicker
                picker='month'
                placeholder={["年/月", "年/月"]}
                format='YYYY/MM'
                disabledDate={disabledDate}
              />
            )}
          </FormItem>
          <FormItem label='模式' name='mode' initialValue="0" rules={[{ required: true }]}>
            <Radio.Group
              value={this.state.radio2value}
              defaultValue="1"
              onChange={this.radioChange2}
              disabled={this.state.dlType === "2" && this.state.areaType === "2"}>
              <Radio value='0'>
                细分{" "}
                <Tooltip title='根据选择的时间范围按每天/每月为一条数据导出，如：选择6月1号至10号，则导出的数据为10条，每天一条。'>
                  <QuestionCircleOutlined />
                </Tooltip>
              </Radio>
              <Radio value='1'>
                汇总{" "}
                <Tooltip title='不管选择的多长时间，只导出一条数据，如：选择6月1号至10号，则导出的数据为1条，范围包括1到10号。'>
                  <QuestionCircleOutlined />
                </Tooltip>
              </Radio>
            </Radio.Group>
          </FormItem>
        </Form>
        <div className='submitBtns'>
          <Button
            type='primary'
            onClick={() => {
              this.submitForm();
            }}
            disabled={this.state.btnClicked}>
            {" "}
            导出{" "}
          </Button>
          {/* <Button type='default' onClick={this.resetForm } > 重置 </Button> */}
        </div>
      </div>
    );
    return Content;
  }
}

export default AddDownloadTask;



// WEBPACK FOOTER //
// ./src/AntD/pages/onlineOperations/IndicatorDataDownload/addDownloadTask.js